// ============================================================
//  src/config.js
//  UPDATE THIS FILE to change store settings
// ============================================================

const config = {
  // Store Info
  storeName: "RK Farm Foods",
  tagline: "Authentic Quality.",
  description: "Organic millets, ancient grains & natural sweeteners from India's finest farms",

  // Contact
  phone: "+91 63808 20182",
  email: "rkfarmfoods@gmail.com",
  location: "Coimbatore, Tamil Nadu",
  hours: "Mon-Sat, 9AM-6PM",

  // WhatsApp Business (country code + number, no + or spaces)
  whatsappNumber: "916380820182",

  // Social links (optional) - update with real profiles
  social: {
    facebook: "https://www.facebook.com/profile.php?id=61586841372580",
    instagram: "https://www.instagram.com/rkfarmfoods",
  },

  // Bank Details  UPDATE with your real bank details
  bank: {
    accountName:   "RK Farm Foods",
    accountNumber: "23510200006030",
    ifscCode:      "FDRL0002351",
    bankName:      "Fedaral Bank",
    branch:        "Sundarapuram Branch",
    accountType:   "Current Account",
  },

  // Legal & Compliance  UPDATE with your real license numbers
  fssaiLicense:  "22426011000127",
  fssaiValidUpto: "February 2027",
  gstNumber:     "33EORPR8334R1ZR",
  gstState:      "Tamil Nadu (33)",

  // Branding
  totalRatings: 8,
  totalFollowers: 2,
  rating: 5.0,

  // Theme Colors
  colors: {
    primary:      "#2d5a27",
    primaryLight: "#4a8c3f",
    accent:       "#e67e22",
    background:   "#faf8f5",
    cardBorder:   "#f0ebe3",
    text:         "#1a1a1a",
    textMuted:    "#888",
  },
};

export default config;
